module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 d-flex flex-wrap py-3"
  }, [(_vm.reservation.event.product) ? _c('extra-selector', {
    staticClass: "w-100",
    attrs: {
      "reservation": _vm.reservation
    }
  }) : _c('div', {
    staticClass: "text-center fs-large dark w-100"
  }, [_vm._v("\n        No extras available\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1e55f982", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e55f982"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabExtras.vue
// module id = 1953
// module chunks = 0